'use client';
import { create } from 'zustand';
import { IPaymentConnector } from '~/modules/payment/synchrony/payment-connector';

interface OrderInProgressType {
  orderInProgress: boolean;
  affirmDialogOpen: boolean;
  setOrderInProgress: (value: boolean) => void;
  setAffirmDialogOpen: (value: boolean) => void;
  isSubmitOrderDisabled: boolean;
  setIsSubmitOrderDisabled: (value: boolean) => void;
  acceptContent: IPaymentConnector | null;
  setAcceptContent: (value: IPaymentConnector | null) => void;
  cartId: string;
  setCartId: (value: string) => void;
}

type SetStateFn = (
  partial:
    | Partial<OrderInProgressType>
    | ((state: OrderInProgressType) => Partial<OrderInProgressType>),
) => void;

const useOrderInProgressStore = create<OrderInProgressType>(
  (set: SetStateFn) => ({
    orderInProgress: false,
    affirmDialogOpen: false,
    isSubmitOrderDisabled: false,
    acceptContent: null,
    cartId: '',
    setOrderInProgress: (value: boolean) => set({ orderInProgress: value }),
    setAffirmDialogOpen: (value: boolean) => set({ affirmDialogOpen: value }),
    setIsSubmitOrderDisabled: (value: boolean) =>
      set({ isSubmitOrderDisabled: value }),
    setAcceptContent: (value: IPaymentConnector | null) =>
      set({ acceptContent: value }),
    setCartId: (value: string) => set({ cartId: value }),
  }),
);

export const useOrderInprogress = () => {
  return useOrderInProgressStore();
};
